import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';


import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Typography } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';

import Add from '@mui/icons-material/Add';


import FundingSourceTile from '../paymentsources/FundingSourceTile';
import ACHFormII from '../paymentsources/ACHFormII';
import PaymentFormII from '../paymentsources/PaymentFormII';
import PaymentSourceDialog from '../ui/PaymentSourceDialog';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import ServerError from '../ui/ServerError';
import AccountUpdateMutation from '../account/AccountUpdateMutation';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import { yellow } from '@mui/material/colors';



const abEnvironment = new AbEnvironment();
const CustomerFundingSourceStepQuery = graphql`
query CustomerFundingSourceStepQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountNum
    accountName
    contactLastName
    contactFirstName
    contactEmail
    contactPhone
    address1
    address2
    city
    state
    country
    postalCode
    dwollaCid
    stripeCid
    achActive
    accountTByParentId {
      accountName
    }
    paymentSourceTsByAccountId (orderBy: PS_ORDER_ASC) {
      totalCount
      nodes {
        psType
        psStatus
        ccBrand
        ccLast4
        ccExpy
        fiName
        achAccountNum
        firstName
        lastName
      }
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  percentageTextField: {
    marginTop: -4,
    marginLeft: 16,
    width: 60,
    minWidth: 60,
    textAlign: 'right',
    paddingLeft: 0
  },
  radio: {
    marginTop: -10,
    marginLeft: 16,
  },
  info: {
    marginTop: -12,
    marginBottom: 8
  }
});

class CustomerFundingSourceStep extends React.Component {
  
  state = {
    country:    null,
    state:      null,
    city:       null,
    postalCode: null,
    address1:   null,
    address2:   null,
    showSpinner: false,
    showACHSpinner: false,
    ccOpen: false,
    achOpen: false,

    forceFetch: 1
  }

  isAddressComplete(queryProps) {

    if (this.getValueForRender(this.state.address1,   queryProps.accountTByAccountId.address1, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.city,   queryProps.accountTByAccountId.city, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.state,   queryProps.accountTByAccountId.state, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.postalCode,   queryProps.accountTByAccountId.postalCode, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.country,   queryProps.accountTByAccountId.country, '') === '') {
      return false;
    }

    return true;
  }

  isPaymentSourceComplete(queryProps) {

    if (queryProps.accountTByAccountId.paymentSourceTsByAccountId.totalCount > 0) {
      return true;
    }

    return false;
  }

  isInformationComplete(queryProps) {

    if (this.isAddressComplete(queryProps) && this.isPaymentSourceComplete(queryProps)) {
      return true;
    } else {
      return false;
    }
  }

  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled(queryProps) {

    if (this.props.activeStep === this.props.assignedStep) {
      if (!this.isInformationComplete(queryProps)) {
        return true;
      } 
    }
    return false;
  }

  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  
  openCCDialog = (event) => {
    var storageSteps = localStorage.getItem('authorizeSteps');
    let totalSteps = 0;
    if (storageSteps) {
      let steps = JSON.parse(storageSteps);
      totalSteps = steps.length - 1;
    }

    let url = '/steppercustomerauthorize?step=' + totalSteps;

    if (this.props.location) {
      const params = new URLSearchParams(this.props.location.search);
      let projectIdParm = params.get('projectId');
      if (projectIdParm) {
        url = url + '&projectId=' + projectIdParm;
      }
    }
    
    localStorage.setItem('paymentReturn', url);

    this.setState({ccOpen: true, showSpinner: false});
  }

  handleCCClose = () => {
    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    localStorage.removeItem('paymentReturn');
    this.setState({ccOpen: false, showSpinner: false, forceFetch: newForceFetch});
  };
    
  openACHDialog = (event) => {

    //need steps to always return to last one
    var storageSteps = localStorage.getItem('authorizeSteps');
    let totalSteps = 0;
    if (storageSteps) {
      let steps = JSON.parse(storageSteps);
      totalSteps = steps.length - 1;
      
    }

    let url = '/steppercustomerauthorize?step=' + totalSteps;

    if (this.props.location) {
      const params = new URLSearchParams(this.props.location.search);
      let projectIdParm = params.get('projectId');
      if (projectIdParm) {
        url = url + '&projectId=' + projectIdParm;
      }
    }

    localStorage.setItem('paymentReturn', url);
    localStorage.removeItem('plaid');
    this.setState({achOpen: true, showSpinner: false});
  }

  handleACHClose = () => {
    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    localStorage.removeItem('paymentReturn');
    localStorage.removeItem('plaid');
    this.setState({achOpen: false, showSpinner: false, forceFetch: newForceFetch});
  };

  showSpinner() {
    return this.state.showSpinner;
  }

  showACHSpinner() {
    return this.state.showACHSpinner;
  }

  setStripeCidOnUInfo = (stripeCid) => {
    //this is a no op here. The page is reloaded after card is entered and that refetches.
  }
  setDwollaCidOnUInfo = (dwollaCid) => {
    //this is a no op here. The page is reloaded after card is entered and that refetches.
  }

  isACHAllowed(uInfo) {
   
    if (this.props.auth.isUnauthenticatedCustomer()) {
      return false;
    }
    
    if (uInfo.achActive === "0") {
      return false;
    }
    if ((uInfo.contactFirstName === null) || (uInfo.contactLastName === null) || (uInfo.email === null)  || (uInfo.address1 === null)) {
      return false;
    }
    return true;
  }

  render() {
    const { logError } = this.props.auth;
    const yellowColor = yellow[600];

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    }
    
    let skipAllowed = false;
   
    let acctId = abEnvironment.getUserAttribute("a_id");

    var connected = false;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={CustomerFundingSourceStepQuery}
        variables={{accountId: acctId, forceFetch: this.state.forceFetch}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {


            let uInfo = {
              accountId:   props.accountTByAccountId.accountId,
              accountName: props.accountTByAccountId.accountName,
              description: props.accountTByAccountId.description,
              firstName:   props.accountTByAccountId.contactFirstName,
              lastName:    props.accountTByAccountId.contactLastName,
              email:       props.accountTByAccountId.contactEmail,
              phone:       props.accountTByAccountId.contactPhone,
              address1:    props.accountTByAccountId.address1,
              address2:    props.accountTByAccountId.address2,
              city:        props.accountTByAccountId.city,
              state:       props.accountTByAccountId.state,
              country:     props.accountTByAccountId.country,
              postalCode:  props.accountTByAccountId.postalCode,
              dwollaCid:   props.accountTByAccountId.dwollaCid,
              stripeCid:   props.accountTByAccountId.stripeCid,
              achActive:   props.accountTByAccountId.achActive
            };

            //console.log(JSON.stringify(props));

            // Is there already a payment source?
            let achAdded = false;
            let ccAdded = false;
            let ccPaymentSource = null;
            let achPaymentSource = null
            for (let i = 0; i < props.accountTByAccountId.paymentSourceTsByAccountId.nodes.length; i++) {
              let ps =  props.accountTByAccountId.paymentSourceTsByAccountId.nodes[i];
              if (ps.psType === 0 && ps.psStatus === 0 && !ccAdded) {
                ccAdded = true;
                connected = true;
                ccPaymentSource = props.accountTByAccountId.paymentSourceTsByAccountId.nodes[i];
                break;
              } else if (ps.psType === 1 && !achAdded) {  //note status is not here
                achAdded = true;
                connected = true;
                achPaymentSource = props.accountTByAccountId.paymentSourceTsByAccountId.nodes[i];
                break;
              }
            }

            let instructions = 'Link your payment method to authorize ' +  props.accountTByAccountId.accountTByParentId.accountName + ' to purchase subscriptions on your behalf.'
            if (!displayOnly) {
              return (
        
                <Grid container spacing={2}  style={{marginTop: 8}}>
          
                  <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="flex-start">

                      {!connected &&
                      <Grid item>
                        <Typography variant="body1">
                        {instructions}
                        </Typography>
                      </Grid>
                      }
                      {ccAdded &&
                      <Grid item style={{marginLeft: -12}} >
                          <FundingSourceTile 
                                    psType={ccPaymentSource.psType}
                                    ccBrand={ccPaymentSource.ccBrand}
                                    ccLast4={ccPaymentSource.ccLast4}
                                    ccExpy={ccPaymentSource.ccExpy}
                                    fiName={ccPaymentSource.fiName}
                                    achAccountNum={ccPaymentSource.achAccountNum}
                                    firstName={ccPaymentSource.firstName}
                                    lastName={ccPaymentSource.lastName}
                                  />
                      </Grid>
                      }
                      {achAdded &&
                      <React.Fragment>
                      <Grid item style={{marginLeft: -12}}>
                        <FundingSourceTile 
                                    psType={achPaymentSource.psType}
                                    ccBrand={achPaymentSource.ccBrand}
                                    ccLast4={achPaymentSource.ccLast4}
                                    ccExpy={achPaymentSource.ccExpy}
                                    fiName={achPaymentSource.fiName}
                                    achAccountNum={achPaymentSource.achAccountNum}
                                    firstName={achPaymentSource.firstName}
                                    lastName={achPaymentSource.lastName}
                                  />
                       </Grid>
                       <Grid item xs={12}>
                          {achPaymentSource && achPaymentSource.psStatus === 4 &&
                          <React.Fragment>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" style={{marginTop: 8}}>
                              <Grid item>
                                <HourglassEmpty htmlColor={yellowColor} style={{marginRight: 8}}/>
                                <Typography display="inline" variant="subtitle2">
                                  Connecting to your bank account
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="caption">
                                  A connection to your account is being established.  You'll be notified when your account is verified, or if you need to take
                                  further steps to verify your account.
                                </Typography>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                          }
                          {/* 4: Pending state - waiting for microdeposits to be made */}
                          {achPaymentSource && achPaymentSource.psStatus === 5 &&
                          <React.Fragment>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start"  style={{marginTop: 8}}>
                              <Grid item>
                                <HourglassEmpty htmlColor={yellowColor} style={{marginRight: 8}}/>
                                <Typography display="inline" variant="subtitle2">
                                  Waiting for microdeposits
                                </Typography>
                              </Grid>
                               <Grid item>
                                <Typography variant="caption">
                                  To verify your bank account information, two deposits of 10 cents or less have been initiated via ACH transfer.
                                  When these deposits have completed, you'll be notified so that you can enter the deposit amounts here to verify your account.
                                </Typography>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                          }

                        </Grid>
                       </React.Fragment>
                      }

                    </Grid>
                  </Grid>
                  
                  {!connected && !this.showSpinner() &&
                  <Grid item xs={12} style={{marginBottom: 16}}>
                    <Grid container spacing={2} >
                    
                      {!this.showSpinner() &&
                      <Grid item>
                        <Button color="primary" 
                                disabled={!this.isAddressComplete(props)}
                                variant="contained"
                                onClick={() => { this.openCCDialog();}}>
                            <Add/>{' credit card'}
                        </Button>
                      </Grid>
                      }

                      {this.showSpinner() &&
                      <Grid item>
                        <Grid item>
                          <Button color="primary" 
                                  variant="contained">
                              <SavingSpinner/>
                          </Button>
                        </Grid>
                      </Grid>
                      }


                      {!this.showACHSpinner() &&
                      <Grid item>
                        <Button color="primary" 
                                disabled={!this.isAddressComplete(props)}
                                variant="outlined"
                                onClick={() => { this.openACHDialog();}}>
                            <Add/>US bank account (ACH)
                        </Button>
                      </Grid>
                      }
                      
                      {this.showACHSpinner() &&
                      <Grid item>
                        <Button color="primary" 
                                variant="outlined">
                            <SavingSpinner/>
                        </Button>
                      </Grid>
                      }
                      
                    </Grid>
                  </Grid>
                  }
                  {!connected && this.showSpinner() &&
                    <Grid item xs={12} style={{marginBottom: 16}}>
                      <Grid container spacing={2} >
                      
                        <Grid item>
                          <Button color="primary" 
                                  variant="contained">
                              <SavingSpinner/>
                          </Button>
                        </Grid>
                        
                      </Grid>
                    </Grid>
                   }

                <PaymentSourceDialog
                      title="Add credit card"
                      open={this.state.ccOpen}
                      onClose={this.handleCCClose} >
                          <PaymentFormII pcId={uInfo.stripeCid} 
                                      dAccountId={uInfo.accountId}
                                      dAccountName={uInfo.accountName}
                                      dFirstName={uInfo.firstName}
                                      dLastName={uInfo.lastName}
                                      dEmail={uInfo.email}
                                      dPhone={uInfo.phone}
                                      dAddress1={uInfo.address1}
                                      dAddress2={uInfo.address2}
                                      dCity={uInfo.city}
                                      dState={uInfo.state}
                                      dCountry={uInfo.country}
                                      dPostalCode={uInfo.postalCode}
                                      auth={this.props.auth}
                                      porder={0}
                                      setStripeCid={this.setStripeCidOnUInfo}
                                      history={this.props.history}
                                      onClose={this.handleCCClose}
                          />
                    </PaymentSourceDialog>


                    <PaymentSourceDialog
                      title="Add ACH"
                      open={this.state.achOpen}
                      onClose={this.handleACHClose} >
                      <ACHFormII pcId={uInfo.dwollaCid} 
                              dAccountId={uInfo.accountId}
                              dAccountName={uInfo.accountName}
                              dFirstName={uInfo.firstName}
                              dLastName={uInfo.lastName}
                              dEmail={uInfo.email}
                              dPhone={uInfo.phone}
                              dAddress1={uInfo.address1}
                              dAddress2={uInfo.address2}
                              dCity={uInfo.city}
                              dState={uInfo.state}
                              dCountry={uInfo.country}
                              auth={this.props.auth}
                              porder={0}
                              setDwollaCidOnUInfo={this.setDwollaCidOnUInfo}
                              history={this.props.history}
                              onClose={this.handleACHClose}
                              />
                    </PaymentSourceDialog>


                    {this.props.activeStep === this.props.assignedStep &&
                    <Grid item xs={12}>
                      
                      
                      <Button
                        color="primary" variant="contained"
                        disabled={!connected}
                        onClick={() => this.props.handleNext()}
                        style={AppBindStyles.bottomButton}>
                         Confirm
                      </Button>
                      
                      {skipAllowed && !connected &&
                        <Button
                          color="primary" variant="outlined"
                          onClick={() => { this.props.handleNext();}}
                          style={AppBindStyles.bottomButton}>
                          Skip
                        </Button>
                      }
                    </Grid>
                      
                  } 
                </Grid>       
              );
          
            } else {
              //display only
              return (
        
                <Grid container style={{marginTop: 8}}>
                {connected &&
                  <React.Fragment>
                    <Grid item xs={12}  style={{marginBottom: 8}}>
                      <Typography variant="body1">
                        You have connected a funding source.
                      </Typography>
                    </Grid>
                    
                  </React.Fragment>
                  }
                  {ccAdded &&
                  <Grid item style={{marginLeft: -12}} >
                      <FundingSourceTile 
                                psType={ccPaymentSource.psType}
                                ccBrand={ccPaymentSource.ccBrand}
                                ccLast4={ccPaymentSource.ccLast4}
                                ccExpy={ccPaymentSource.ccExpy}
                                fiName={ccPaymentSource.fiName}
                                achAccountNum={ccPaymentSource.achAccountNum}
                                firstName={ccPaymentSource.firstName}
                                lastName={ccPaymentSource.lastName}
                              />
                  </Grid>
                  }
                  {achAdded &&
                  <React.Fragment>
                  <Grid item style={{marginLeft: -12}}>
                    <FundingSourceTile 
                                psType={achPaymentSource.psType}
                                ccBrand={achPaymentSource.ccBrand}
                                ccLast4={achPaymentSource.ccLast4}
                                ccExpy={achPaymentSource.ccExpy}
                                fiName={achPaymentSource.fiName}
                                achAccountNum={achPaymentSource.achAccountNum}
                                firstName={achPaymentSource.firstName}
                                lastName={achPaymentSource.lastName}
                              />
                    </Grid>
                       <Grid item xs={12}>
                       {achPaymentSource && achPaymentSource.psStatus === 4 &&
                        <React.Fragment>
                          <Grid container spacing={1} direction="column" justifyContent="flex-start" style={{marginTop: 8}}>
                            <Grid item>
                              <HourglassEmpty htmlColor={yellowColor} style={{marginRight: 8}}/>
                              <Typography display="inline" variant="subtitle2">
                                Connecting to your bank account
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption">
                                A connection to your account is being established.  You'll be notified when your account is verified, or if you need to take
                                further steps to verify your account.
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                        }
                       {/* 4: Pending state - waiting for microdeposits to be made */}
                       {achPaymentSource && achPaymentSource.psStatus === 5 &&
                        <React.Fragment>
                          <Grid container spacing={1} direction="column" justifyContent="flex-start"  style={{marginTop: 8}}>
                            
                            <Grid item>
                              <HourglassEmpty htmlColor={yellowColor} style={{marginRight: 8}}/>
                              <Typography display="inline" variant="subtitle2">
                                Waiting for microdeposits
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption">
                                To verify your bank account information, two deposits of 10 cents or less have been initiated via ACH transfer.
                                When these deposits have completed, you'll be notified so that you can enter the deposit amounts to verify your account.
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                       }

                     </Grid>
                     </React.Fragment>
                  }

                {!connected &&
                  <React.Fragment>
                    <Grid item xs={12}>
                      <Typography variant="caption">
                        Skipped
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  }
                </Grid>
                  
              );
        
            }
          }
          if (!displayOnly) {
            return <div><LoadingSpinner/></div>
          }
        }
      }
      />
    );

  }

  updateBillingAddress = (acctId) => {

    const { logError } = this.props.auth;
    const { address1, address2, city, state, country, postalCode } = this.state;
    if (address1 === null && address2 === null && city === null && state === null && postalCode === null && country === null) {
      //nothing changed - move on
      this.openCCDialog();
      return;
    }

    this.setState({showSpinner: true});    


    AccountUpdateMutation.commit(acctId, null, null, null, null,
                                 null, null, null, null,
                                 address1, address2, city, state, country, postalCode,
                                 null, null, null, null, null,
                                 null, null, null)
    .then(response => {

      //this.props.handleNext();
      this.openCCDialog();
       
     })
    .catch(error => {
      logError('Exception in CustomerFundingSourceStep.js: ' + error);
    });
  }


}


CustomerFundingSourceStep.propTypes = {
  account: PropTypes.object.isRequired,
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(CustomerFundingSourceStep);
